module.exports = __webpack_public_path__ + "static/media/admin_img.57d5e012.jpg";